// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-bar {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding: 0 25px;
    margin-right: 2vw;
    margin-top: 7.5vh;
    width: 12.5vw;
}
.nav-btn {
    border: none;
    font-size: 1rem;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
    background-color: white;
    padding: 5px 10px;
    transition: background-color 300ms;
}
.nav-btn:hover {
    background-color: var(--background-color-hover);
    transition: background-color 300ms;
    border-radius: 6px;
}
.nav-icon {
    width: 1.8rem;
    height: 1.8rem;
}
#filters-labels-container {
    position: relative;
    width: 100%;
}
#filters-labels-btn {
    width: 100%;
}
.dropdown-indicator-img {
    width: 1.8rem;
    height: 1.8rem;
    margin-left: auto;
}
#filters-labels-dialog {
    position: absolute;
    top: 110%;
    width: 100%;
    appearance: none;
    border: none;
    padding: 15px 0 0 0;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    transition: height 500ms;
}
#filters-labels-dialog:not([open]) {
    height: 0% !important;
    opacity: 0;
    overflow: hidden;
    transition: height 500ms;
}
#filters-labels-dialog[open] {
    height: 100%;
    transition: height 500ms;
}
#filters-labels-dialog button {
    appearance: none;
    border: 0;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 85%;
    background-color: transparent;
    border-radius: 6px;
    padding: 5px 10px;
}
#filters-labels-dialog button:hover {
    background-color: rgba(128, 128, 128, 0.25);
    transition: background-color 400ms;
}
#filters-labels-dialog .btn-icon {
    width: 1.8rem;
    height: 1.8rem;
}
#filters-labels-dialog .btn-text {
    text-align: left;
}
@media only screen and (max-width:600px)  { 
    #sidebar-menu-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 12.5vw;
        border-radius: 100px;
        padding: 10px 10px;
    }
    .nav-bar {
        display: none;
        overflow: hidden;
    }
}
@media only screen and (min-width:600px) and (max-width: 961px) { 
    /* tablet, landscape iPad, lo-res laptops ands desktops */ 
    .nav-bar {
        width: 20vw;
        margin-top: 10vh;
        margin-left: 10px;
        padding-left: 0;
        padding-right: 0;
    }
    .nav-bar p {
        font-size: 1.3rem;
    }
}
@media only screen and (min-width:961px) and (max-width: 1025px) { 
    /* big landscape tablets, laptops, and desktops */ 
    .nav-bar {
        width: 20vw;
        margin-top: 10vh;
        margin-left: 10px;
        padding-left: 0;
        padding-right: 0;
    }
    .nav-bar p {
        font-size: 1.7rem;
    }
}
@media (min-width:1281px) {
     /* hi-res laptops and desktops */
    .nav-bar {
        margin-top: 12.5vh;
    }
    .nav-btn {
        font-size: 1.4rem;
    }
    #filters-labels-dialog button {
        appearance: none;
        border: 0;
        cursor: pointer;
        font-size: 1.4rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kCAAkC;AACtC;AACA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,oBAAoB;QACpB,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;AACA;IACI,yDAAyD;IACzD;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,iDAAiD;IACjD;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;KACK,gCAAgC;IACjC;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,SAAS;QACT,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".nav-bar {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    padding: 0 25px;\n    margin-right: 2vw;\n    margin-top: 7.5vh;\n    width: 12.5vw;\n}\n.nav-btn {\n    border: none;\n    font-size: 1rem;\n    text-align: left;\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n    background-color: white;\n    padding: 5px 10px;\n    transition: background-color 300ms;\n}\n.nav-btn:hover {\n    background-color: var(--background-color-hover);\n    transition: background-color 300ms;\n    border-radius: 6px;\n}\n.nav-icon {\n    width: 1.8rem;\n    height: 1.8rem;\n}\n#filters-labels-container {\n    position: relative;\n    width: 100%;\n}\n#filters-labels-btn {\n    width: 100%;\n}\n.dropdown-indicator-img {\n    width: 1.8rem;\n    height: 1.8rem;\n    margin-left: auto;\n}\n#filters-labels-dialog {\n    position: absolute;\n    top: 110%;\n    width: 100%;\n    appearance: none;\n    border: none;\n    padding: 15px 0 0 0;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    transition: height 500ms;\n}\n#filters-labels-dialog:not([open]) {\n    height: 0% !important;\n    opacity: 0;\n    overflow: hidden;\n    transition: height 500ms;\n}\n#filters-labels-dialog[open] {\n    height: 100%;\n    transition: height 500ms;\n}\n#filters-labels-dialog button {\n    appearance: none;\n    border: 0;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    width: 85%;\n    background-color: transparent;\n    border-radius: 6px;\n    padding: 5px 10px;\n}\n#filters-labels-dialog button:hover {\n    background-color: rgba(128, 128, 128, 0.25);\n    transition: background-color 400ms;\n}\n#filters-labels-dialog .btn-icon {\n    width: 1.8rem;\n    height: 1.8rem;\n}\n#filters-labels-dialog .btn-text {\n    text-align: left;\n}\n@media only screen and (max-width:600px)  { \n    #sidebar-menu-btn {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 12.5vw;\n        border-radius: 100px;\n        padding: 10px 10px;\n    }\n    .nav-bar {\n        display: none;\n        overflow: hidden;\n    }\n}\n@media only screen and (min-width:600px) and (max-width: 961px) { \n    /* tablet, landscape iPad, lo-res laptops ands desktops */ \n    .nav-bar {\n        width: 20vw;\n        margin-top: 10vh;\n        margin-left: 10px;\n        padding-left: 0;\n        padding-right: 0;\n    }\n    .nav-bar p {\n        font-size: 1.3rem;\n    }\n}\n@media only screen and (min-width:961px) and (max-width: 1025px) { \n    /* big landscape tablets, laptops, and desktops */ \n    .nav-bar {\n        width: 20vw;\n        margin-top: 10vh;\n        margin-left: 10px;\n        padding-left: 0;\n        padding-right: 0;\n    }\n    .nav-bar p {\n        font-size: 1.7rem;\n    }\n}\n@media (min-width:1281px) {\n     /* hi-res laptops and desktops */\n    .nav-bar {\n        margin-top: 12.5vh;\n    }\n    .nav-btn {\n        font-size: 1.4rem;\n    }\n    #filters-labels-dialog button {\n        appearance: none;\n        border: 0;\n        cursor: pointer;\n        font-size: 1.4rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
